module.exports = __webpack_public_path__ + "img/icon-exit.43ed5f20.svg";